package org.chiangmeng.qfast

import androidx.compose.runtime.Composable
import cafe.adriel.voyager.navigator.Navigator
import org.chiangmeng.qfast.core.ui.customer.CustomerScreen
import org.chiangmeng.qfast.core.util.getUrlShopId
import org.chiangmeng.qfast.core.util.getUrlTicketNumber
import org.chiangmeng.qfast.features.auth.AuthScreen

@Composable
fun App() {
    initKoin()
    val initialShopId = getUrlShopId()
    val initialTicket = getUrlTicketNumber()

    val initialScreen = if (!initialShopId.isNullOrBlank()) {
        CustomerScreen(shopId = initialShopId, ticketNumber = initialTicket)
    } else {
        AuthScreen()
    }

    Navigator(initialScreen)
}
